import { useMemo } from 'react';
import styles from './TenantSelector.module.css';
import { TenantSelectorBody } from './TenantSelectorBody';
import { TenantSyncModeSelector } from './TenantSyncModeSelector';
import type { TenantSelectorProps, TenantSyncMode } from './types';

export function TenantSelector({
  tenantSelectionType,
  selectedTenantIds,
  onChange,
  allTenantsSelectionDescription,
  selectedTenantsSelectionDescription,
  disabled = false,
  tenantRowData,
  listOnly = false,
  isLoading = false,
  includeDraftOption = false,
  draftSelectionDescription,
}: TenantSelectorProps) {
  const allCurrentTenantIds = useMemo(() => Object.keys(tenantRowData), [tenantRowData]);

  const isDraft =
    includeDraftOption && tenantSelectionType === 'selected' && selectedTenantIds.length === 0;
  let mode: TenantSyncMode = 'selected';
  if (tenantSelectionType === 'all') {
    mode = 'all';
  } else if (isDraft) {
    mode = 'draft';
  }

  const handleModeChange = (nextMode: TenantSyncMode) => {
    if (disabled) {
      return;
    }
    if (nextMode === 'all') {
      onChange('all', selectedTenantIds);
    } else if (nextMode === 'draft') {
      onChange('selected', []);
    } else {
      const newIds = selectedTenantIds.length > 0 ? selectedTenantIds : allCurrentTenantIds;
      onChange('selected', newIds);
    }
  };

  return (
    <section className={listOnly ? undefined : styles.section}>
      {!listOnly && (
        <TenantSyncModeSelector
          mode={mode}
          onModeChange={handleModeChange}
          includeDraftOption={includeDraftOption}
          allTenantsSelectionDescription={allTenantsSelectionDescription}
          selectedTenantsSelectionDescription={selectedTenantsSelectionDescription}
          draftSelectionDescription={draftSelectionDescription}
          disabled={disabled}
        />
      )}

      <div className={styles.body}>
        <TenantSelectorBody
          tenantSelectionType={tenantSelectionType}
          selectedTenantIds={selectedTenantIds}
          tenantRowData={tenantRowData}
          disabled={disabled}
          onChange={onChange}
          hideToolbar={listOnly}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
}
